// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3Axes","rootCenter":"LoadMoreObserver_rootCenter__2-MSU","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__xl2q-"};